module.exports = __webpack_public_path__ + "media/2.4b965cdb.wav";